import axios from '@/axios.js'

export default {

  fetchCustomerDashboardItems ({ commit }, logins) {
    return new Promise((resolve, reject) => {
      const queryString = Object.keys(logins).map(key => 'logins=' + logins[key]).join('&')
      axios.get(`${process.env.VUE_APP_API_GATEWAY_BASE_PATH  }/Mt4ReportServer-Api/GetCustomerDashbordItems?${queryString}`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { 
          reject(error) 
        })
    })
  }
}
